export default __webpack_public_path__ + "static/media/q7.36ae3cee.svg";